import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import BaseButton from "../../../../components/BaseButton";
import LandingHeaderBf from "../../../../assets/images/landing_header_bf.png";
import "./style.scss";

export default function SectionCompatibilityTest({ onStartTest, isLoading }) {
  SectionCompatibilityTest.propTypes = {
    onStartTest: PropTypes.func,
    isLoading: PropTypes.bool,
  };
  const { t } = useTranslation();

  const titleLines = [
    t("compatibility_share_page.title_line1"),
    t("compatibility_share_page.title_line2"),
    t("compatibility_share_page.title_line3"),
  ];
  const titleFull = titleLines.join(" ");

  return (
    <section className="section-compatibility-test">
      <div className="eclipse eclipse-test-1"></div>
      <div className="eclipse eclipse-test-2"></div>
      <div className="eclipse eclipse-test-3"></div>
      <div className="section-compatibility-test__butterfly">
        <img src={LandingHeaderBf} alt="Wepurplay" />
        <div className="section-compatibility-test__title-stack">
          {titleLines.map((line, idx) => (
            <div
              key={idx}
              className="section-compatibility-test__title neon-text"
              data-text={line}
            >
              {line}
            </div>
          ))}
        </div>
      </div>
      <p className="section-compatibility-test__subtitle">
        {t("compatibility_share_page.text")}
      </p>
      <BaseButton
        className="section-compatibility-test__cta"
        onClick={onStartTest}
        disabled={isLoading}
        aria-label={titleFull}
      >
        {t("section_compatibility.start_test")}
      </BaseButton>
      <p className="section-compatibility-test__description">
        {t("section_compatibility.description")}
      </p>
    </section>
  );
}
